import 'semantic-ui-css/semantic.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import './assets/stylesheets/react-split-pane.css';
import { createRoot } from 'react-dom/client';
import { App } from './app';

const container = document.getElementById('app') as HTMLElement;
const root = createRoot(container);
root.render(<App />);
